/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const orgUnit = {
  header: 'Todas las unidades ({{count}})',
  unit: 'Unidad',
  name: 'Nombre',
  uid: 'Código',
  approvalProcess: 'Proceso de aprobación',
  parentUnit: 'Unidad padre',
  active: 'Estado',
  hint: 'Las unidades representan departamentos, tiendas, regiones o cualquier otra agrupación lógica que tenga sentido para usted. Los centros de coste y las direcciones de entrega disponibles para un comprador en el momento de la compra dependen de su unidad. Los usuarios tienen acceso a todas las unidades secundarias de su unidad principal.',
  details: {
    title: 'Unidad Detalles',
    subtitle: 'Unidad: {{ item.name }}',
    hint: 'Las unidades representan departamentos, tiendas, regiones o cualquier otra agrupación lógica que tenga sentido para usted. Al deshabilitar una unidad, se deshabilitan todos los elementos secundarios de la unidad, incluidas las unidades secundarias, los usuarios, los aprobadores y los centros de costos. Las unidades deshabilitadas no se pueden editar.',
  },
  edit: {
    title: 'Edit Unidad',
    subtitle: 'Unidad: {{ item.name }}',
  },
  create: {
    title: 'Create Unidad',
    subtitle: '',
  },

  messages: {
    deactivateTitle: 'Disable this unit?',
    deactivate: `La desactivación de una unidad tiene efectos de gran alcance en su organización de comercio. También se deshabilitarán TODAS las unidades secundarias, los usuarios, los presupuestos y los centros de costos de la unidad.`,
    confirmEnabled: 'Unidad {{item.name}} habilitada con éxito',
    confirmDisabled: 'Unidad {{item.name}} desactivado con éxito',
    update: 'Unidad {{ item.name }} actualizada con éxito',
    create: 'Unidad {{ item.name }} creada con éxito',
  },
  info: {
    disabledEdit: 'Habilite la unidad para permitir la edición.',
    disabledEnable: 'El padre debe estar habilitado antes de que se pueda habilitar esta unidad.',
    disabledDisable: 'La unidad raíz no se puede desactivar.',
  },

  links: {
    units: 'Unidades hijas:',
    users: 'Usuarios',
    approvers: 'Aprobadores',
    shippingAddresses: 'Direcciones de entrega',
    costCenters: 'Centros de coste',
  },

  tree: {
    expandAll: 'Expandirir todo',
    collapseAll: 'Contraer todo',
    expand: 'Expandir',
    collapse: 'colapso',
  },

  children: {
    create: {
      title: 'Crear unidad secundaria',
      subtitle: '',
    },
    messages: {
      create: 'Unidad {{ item.name }} creada con éxito',
    },
  },

  costCenters: {
    create: {
      title: 'Crear centro de coste',
      subtitle: '',
    },
  },

  form: {
    parentOrgUnit: 'Unidad de negocio matriz',
    create: 'Create Unidad',
    parentOrgUnitNotes:
      'Esta unidad es la unidad de nivel superior de su organización. No se puede asignar a otra unidad.',
  },
  users: {
    header: 'Usuarios in {{code}}',
    changeUserRoles: 'Cambiar los roles de usuario',
    newUser: 'Nuevo usuario',
  },
  assignRoles: {
    header: 'Administrar roles en {{code}}',
    instructions: {
      check: "Para asignar un rol a un usuario, active la casilla de verificación del rol.",
      uncheck: "Para eliminar una función, desactive la casilla de verificación de la función.",
      changes: 'Los cambios se guardan automáticamente.',
    },
  },
  approvers: {
    header: 'Aprobadores in {{code}}',
    assign: 'Administración de aprobadores',
    new: 'Nuevo aprobador',
  },
  assignApprovers: {
    header: 'Administración de aprobadores in {{code}}',
    instructions: {
      check: "Para asignar un aprobador a esta unidad, active la casilla de verificación del usuario.",
      uncheck: "Para quitar un aprobador, desactive la casilla de verificación del usuario.",
      changes: 'Los cambios se guardan automáticamente.',
    },
    hint: "A los usuarios que se muestran en la lista de Aprobadores se les asignan privilegios de aprobación para los compradores de esta unidad y de las unidades secundarias. Tenga en cuenta que un usuario que tiene el rol de aprobador es independiente de un aprobador que aparece en la lista Aprobadores. Si no existe un aprobador para una unidad, o si los aprobadores no tienen suficientes privilegios de compra de aprobación, se encuentra un aprobador más arriba en la jerarquía de unidades, hasta que se elige una administración.",
  },

  breadcrumbs: {
    list: 'Todas las unidades',
    details: '{{name}}',
    children: 'Unidades secundarias',
    users: 'Usuarios',
    approvers: 'Aprobadores',
    addresses: 'Direcciones de entrega',
    addressDetails: '{{formattedAddress}}',
    costCenters: 'Centros de coste',
  },
};

export const orgUnitChildren = {
  title: 'Unidades secundarias',
  subtitle: 'Unidad: {{item.name}}',
  info: {
    disabledCreate: 'No se puede crear una unidad secundaria para una unidad deshabilitada.',
  },
  hint: 'Unidads represent departments, stores, regions, or any other logical grouping that makes sense to you. Usuarios "inherit" child units, meaning buyers have access to cost centers and delivery addresses of child units when checking out.',
};

export const orgUnitAssignedRoles = {
  header: 'Administrar roles en {{code}}',
  name: 'Nombre',
  email: 'Correo electrónico',
  roles: 'Papeles',
  roleCustomer: 'Cliente',
  roleApprover: 'Aprobador',
  roleManager: 'Director',
  roleAdministrator: 'Admin',
};

export const orgUnitApprovers = {
  title: 'Administración de aprobadores',
  subtitle: 'Unidad: {{item.name}}',
  assigned: 'Usuario {{item.name}} asignado correctamente',
  unassigned: 'Usuario {{item.name}} desasignado correctamente',
};

export const orgUnitAssignedApprovers = {
  title: 'Aprobadores asignados',
  subtitle: 'Unidad: {{item.name}}',
  assigned: 'Usuario {{item.name}} asignado correctamente',
  unassigned: 'Usuario {{item.name}} desasignado correctamente',
  hint: "A los usuarios que se muestran en la lista de Aprobadores se les asignan privilegios de aprobación para los compradores de esta unidad y de las unidades secundarias. Tenga en cuenta que un usuario que tiene el rol de aprobador es independiente de un aprobador que aparece en la lista Aprobadores. Si no existe un aprobador para una unidad, o si los aprobadores no tienen suficientes privilegios de compra de aprobación, se encuentra un aprobador más arriba en la jerarquía de unidades, hasta que se elige una administración.",
};

export const orgUnitAssignedUsers = {
  title: 'Usuarios asignados',
  subtitle: 'Unidad: {{item.name}}',
};

export const orgUnitUsers = {
  title: 'Usuarios asignados',
  subtitle: 'Unidad: {{item.name}}',
  info: {
    disabledCreate: 'No se puede crear un usuario para la unidad deshabilitada.',
  },
  hint: 'Usuarios are the buyers, approvers, managers, and administrators of your organization. Each user is assigned a role for making or approving purchases. Usuarios "inherit" child units, meaning buyers have access to cost centers and delivery addresses of child units when checking out.',
};

export const orgUnitUserRoles = {
  title: 'Roles y derechos de usuario',
  subtitle: 'Usuario: {{item.name}}',
  messages: {
    rolesUpdated: 'Papeles actualizados con éxito para {{item.name}}',
  },
};

export const orgUnitCostCenters = {
  title: 'Centros de coste asignados',
  subtitle: 'Unidad: {{item.name}}',
  info: {
    disabledCreate: 'No se puede crear un centro de coste para la unidad inhabilitada.',
  },
  hint: 'All orders placed through your organization\'s purchase account are linked to a cost center for tracking purposes. A buyer selects a cost center when checking out using the "Account" purchase method. Each unit can have multiple cost centers, but a single cost center can only be assigned to a single unit. To define ultimate spending limits, budgets are assigned to cost centers. ',
};

export const orgUnitAddress = {
  title: 'Direcciones de entrega',
  subtitle: 'Unidad: {{item.name}}',

  country: 'País/Región',
  titles: 'Título',
  firstName: 'Nombre',
  lastName: 'Apellido',
  formattedAddress: 'Dirección',
  address1: 'Dirección',
  address2: '2nd address (optional)',
  city: 'Ciudad',
  state: 'Estado',
  zipCode: 'Código postal',
  phoneNumber: 'Número de teléfono (opcional)',
  streetAddress: 'Street Dirección',
  aptSuite: 'Apto, Suite',
  selectOne: 'Seleccione una...',

  hint: 'When a buyer is checking out using the "Account" purchase method, they much choose a cost center. The delivery addresses available to the buyer depend on the unit of the cost center chosen.',
  details: {
    title: 'Dirección details',
    subtitle: 'Unidad: {{item.name}}',
  },
  edit: {
    title: 'Edit Dirección',
  },
  create: {
    title: 'Create Dirección',
  },
  form: {
    subtitle: 'Unidad: {{item.name}}',
  },
  messages: {
    create:
      'Dirección {{ item.firstName }} {{ item.lastName }} creada con éxito',
    update:
      'Dirección {{ item.firstName }} {{ item.lastName }} actualizada con éxito',
    delete:
      'No se puede recuperar la dirección. Los pedidos existentes no se ven afectados.',
    deleteTitle: 'Delete this address?',
    deleted:
      'Dirección {{ item.firstName }} {{ item.lastName }} borrado con éxito',
  },
};
